// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"28f81474","239":"1acf9522","667":"c0a1d2b0"}[chunkId] + ".chunk.js";
};